import { defineMessages } from 'react-intl';

export default defineMessages({
  viewChannel: {
    id: 'widget.mobile.overlay-button.visit-channel',
    defaultMessage: 'Visit channel',
  },
  signIn: {
    id: 'widget.mobile.overlay-button.sign-in',
    defaultMessage: 'Sign in',
  },
  subscribeShortText: {
    id: 'widget.mobile.overlay-button.subscribe.short',
    defaultMessage: 'Subscribe',
  },
});



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/mobile/three-rows-widget/translations.js